import { VerifyFrom } from "./VerifyFrom";
import { TOP_CNT } from "./constants";
import { Fragment, useEffect, useState } from "react";
import { FooterAds } from "../../components/ads/FooterAds";
import { apiMain } from "services";
import "./styles/VerifyPage.scss";

const WAITING_STATUS = "waiting";
const ACCEPTED_STATUS = "accepted";

export const VerifyPage = () => {
  const [verifyStatus, setVerifyStatus] = useState(null);
  const [isStatusSent, setStatusSent] = useState(false);
  const { title, text, verifySentText } = TOP_CNT;

  const getDescription = () => {
    if (
      verifyStatus === WAITING_STATUS ||
      verifyStatus === ACCEPTED_STATUS
    ) {
      return verifySentText;
    }

    return text;
  };

  const fetchUserVerifyStatus = async () => {
    try {
      const { status } = await apiMain.getVerifyUserStatus();
      setVerifyStatus(status);
    } catch (err) {
      console.error(err);
      setVerifyStatus(null);
    }
  };

  const handleStatusSent = (value: boolean) => setStatusSent(value);

  useEffect(() => {
    fetchUserVerifyStatus();
  }, []);

  useEffect(() => {
    if (isStatusSent) {
      fetchUserVerifyStatus();
    }
  }, [isStatusSent]);

  return (
    <Fragment>
      <div className="VerifyPage">
        <div className="VerifyPage-TopCnt">
          <h2>{title}</h2>
          <p>{getDescription()}</p>
        </div>
        {!verifyStatus && <VerifyFrom handleStatusSent={handleStatusSent} />}
      </div>

      <FooterAds/>
    </Fragment>
  );
};
